export default "__VITE_ASSET__SCQP6sHY__"